export default __webpack_public_path__ + "static/media/globalCodes.60bfee4c.svg";